<template>
<div>
    <section class="py-2 py-lg-3 bg-grey-default">
        <div class="container"><!-- Start: breadscrum -->
            <div class="w-100 mb-lg-2">
                <ol class="breadcrumb mb-1 primary-breadcrumb p-1 p-lg-2">
                    <li class="breadcrumb-item"><a href="#"><span><nuxt-link-locale class="a-decoration-none" to="/"><span class="color-main fw-500">Trang chủ</span></nuxt-link-locale></span></a></li>
                    <li class="breadcrumb-item"><a href="#"><span><nuxt-link-locale class="a-decoration-none" :to="'/bo-suu-tap/'+homeSectionDetail.slug"><span class="color-main fw-500">{{homeSectionDetail.sectionName}}</span></nuxt-link-locale></span></a></li>
                </ol>
            </div><!-- End: breadscrum -->
            <div class="mb-2" v-if="homeSectionDetail.banner!==null"><img class="img-fluid w-100" :src="homeSectionDetail.banner" :alt="homeSectionDetail.sectionName"></div><!-- Start: desktop -->
            <div>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <h3 style="margin-bottom: 0;"><span class="pb-1 section-heading">{{homeSectionDetail.sectionName}}</span></h3>
                </div><!-- Start: list relative category -->
                <div class="list-relative-group-product"><!-- Start: list category con -->
                    <div class="d-flex flex-row flex-wrap w-100 py-2 my-lg-3 d-none"><!-- Start: show all -->
                        <div class="category-detail-item-lv2 mb-2 pointer" @click="groupProductsLimit=undefined">
                            <div class="py-2 px-1 category-detail-item-lv2-item see-more-btn">
                                <div class="d-flex justify-content-center align-items-center w-100 h-100 p-1 mb-1 relative-group-product-thumbnail bd-rs-4 primary-box-shadow bg-white"><span class="text-truncate-2">Xem toàn bộ</span></div>
                            </div>
                        </div><!-- End: show all --><!-- Start: show less -->
                        <div class="category-detail-item-lv2 mb-2 pointer" @click="groupProductsLimit=15">
                            <div class="py-2 px-1 category-detail-item-lv2-item see-more-btn">
                                <div class="d-flex justify-content-center align-items-center w-100 h-100 p-1 mb-1 relative-group-product-thumbnail bd-rs-4 primary-box-shadow bg-white"><span>Ẩn bớt</span></div>
                            </div>
                        </div><!-- End: show less -->
                    </div><!-- End: list category con -->
                </div><!-- End: list relative category --><!-- Start: sắp xếp -->
                <div class="d-flex flex-row align-items-center py-1 d-none">
                    <div class="py-1 me-3"><span class="fw-bolder">Text</span><span class="fw-bolder d-none">&nbsp;(<span>Đếm</span>&nbsp;sản phẩm)</span></div>
                    <div class="p-1 me-3 sort-button"><i class="fa fa-sort-amount-asc p-1"></i><span class="ms-1">Giá Thấp - Cao</span></div>
                    <div class="p-1 me-3 sort-button"><i class="fa fa-sort-amount-desc p-1"></i><span class="ms-1">Giá Cao - Thấp</span></div>
                </div><!-- End: sắp xếp -->
            </div><!-- End: desktop --><!-- Start: mobile -->
            <div class="d-none">
                <div class="w-100 mb-3">
                    <h3 class="pb-1 section-heading" style="margin-bottom: 0;text-align: center;font-weight: bold;">Danh Mục&nbsp;</h3>
                </div>
                <div class="d-flex flex-row justify-content-around my-1 pb-2 danh-muc-sort-bar">
                    <div class="d-flex justify-content-center align-items-center px-1" style="width: 34%;" @click="showsortdirectionmoney=!showsortdirectionmoney"><i class="icon-equalizer me-2 p-1"></i><span style="font-size: 12px;line-height: 16px;">Sắp xếp</span></div>
                    <div class="d-flex justify-content-center align-items-center px-1" style="width: 34%;"><button class="btn d-flex align-items-center canvas-danh-muc-con-button" type="button" style="padding: 0;" @click="showcanvasmenubrands=!showcanvasmenubrands"><i class="icon-menu me-2 p-1"></i><span style="font-size: 12px;line-height: 16px;color: rgb(33, 37, 41);">Thương hiệu</span></button></div>
                </div>
            </div><!-- End: mobile --><!-- Start: list product -->
            <div class="mt-3">
                <div>
                    <div class="row g-0 g-2 g-lg-2">
                        <div class="col-6 col-md-4 col-lg-3" v-for="(listProducts,index) in (sortByArray(homeSectionDetail.listProducts,'_id',homeSectionDetail.productsId))" v-bind:key="index"><!-- Start: product-card -->
                            <div class="product-card pointer item-transform-img h-100 p-1 p-lg-2"><nuxt-link-locale class="text-decoration-none text-dark" :to="'/san-pham/'+listProducts.slug">
                                    <div class="item-card-img"><img class="img-fluid w-100" :src="listProducts.image" :alt="listProducts.name"></div>
                                    <div class="item-info-card pt-1"><!-- Start: Basic Price -->
                                        <div class="d-flex justify-content-between item-card-price" v-if="listProducts.marketPrice===listProducts.price || listProducts.marketPrice===null || listProducts.marketPrice===0">
                                            <div><span>{{formatNumberMoney(listProducts?.price)}}</span></div>
                                        </div><!-- End: Basic Price --><!-- Start: discount price -->
                                        <div class="d-flex flex-column justify-content-between flex-md-row item-card-price h-100" v-if="(listProducts.marketPrice!==listProducts.price)&&(listProducts.marketPrice!==null)&&(listProducts.marketPrice!==0)">
                                            <div><span>{{formatNumberMoney(listProducts?.price)}}</span></div>
                                            <div class="d-flex justify-content-between align-items-center"><!-- Start: giá cũ d-none --><span class="old-price">{{formatNumberMoney(listProducts?.marketPrice)}}</span><!-- End: giá cũ d-none -->
                                                <div class="d-flex justify-content-center align-items-center percen-discount h-100 py-1"><span>{{round(((listProducts?.marketPrice-listProducts?.price)/listProducts?.marketPrice)*100,0)}}</span><span>%</span></div>
                                            </div>
                                        </div><!-- End: discount price --><!-- Start: brand -->
                                        <div class="item-card-brand mb-1"><span>{{listProducts?.productBrands?.name}}</span></div><!-- End: brand --><!-- Start: name -->
                                        <div class="name-div cs-pt mb-1"><span class="name text-truncate-2">{{listProducts?.name}}</span></div><!-- End: name --><!-- Start: rating and bought count -->
                                        <div class="d-flex justify-content-between align-items-center h-100 ratting-bought-count"><!-- Start: ratting -->
                                            <div class="ratting"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><!-- End: ratting --><!-- Start: bought-count -->
                                            <div class="bought-count"><i class="icon-basket-loaded me-1"></i><span>{{listProducts?.sellcount}}</span></div><!-- End: bought-count -->
                                        </div><!-- End: rating and bought count -->
                                    </div>
                                </nuxt-link-locale>
                                <div class="mt-2 d-none"><button class="btn btn-primary w-100 btn-signup-lg" type="button" @click="()=>{productCartItem.product=homeSectionDetail.listProducts[index]._id;productCartItem.amount=1;if(!productCart.includes(productCartItem)){productCart.push(productCartItem)};toast?.show({props:{title:'',body:'Đã thêm vào giỏ hàng',variant:'success'}})}">{{$t('themVaoGioHang')}}</button></div>
                            </div><!-- End: product-card -->
                        </div>
                    </div>
                </div>
            </div><!-- End: list product --><!-- Start: pagination -->
            <div class="d-flex justify-content-center align-items-center py-1"><b-pagination class="custom-pagination" v-model="currentPage" :total-rows="homeSectionDetail.soLuongMacDinh" :per-page="4" @update:model-value="()=>{setQuery('page',currentPage);loadDatahomeSectionDetail()}"></b-pagination></div><!-- End: pagination -->
        </div>
    </section><client-only><b-offcanvas placement="end" backdrop title="thương hiệu uy tín" id="offcanvas-2" class="canvas-danh-muc-con" style="width: 90%;">
            <div>
                <div class="row g-0 w-100 g-1">
                    <div class="col-6 pb-2 pt-1"><nuxt-link-locale class="a-decoration-none">
                            <div class="p-1 h-100 canvas-danh-muc-con-item"><span style="font-size: 14px;line-height: 14px;">Text</span></div>
                        </nuxt-link-locale></div>
                </div>
            </div>
        </b-offcanvas><!-- Start: sort-modal-mobile --><b-modal role="dialog" tabindex="-1" id="modal-1">
            <h5>Sắp xếp theo</h5>
            <div class="p-2 mb-2 sort-modal-item" @click="div86361663fdab98dfa50da06a1bd0ac9f9d5fd279click"><span><i class="fa fa-sort-amount-asc p-1"></i>&nbsp;Giá thấp tới cao</span></div>
            <div class="p-2 mb-2 sort-modal-item" @click="divfd367d85fb44e2302c49f15815e46f24538072dfclick"><span><i class="fa fa-sort-amount-desc p-1"></i>&nbsp;Giá cao tới thấp</span></div>
        </b-modal><!-- End: sort-modal-mobile --></client-only>
</div>
</template><script setup>
    import { computed,watch } from 'vue';
    import {sortByArray} from "../../util";





    
    import {formatNumberMoney,} from '../../util';
    

            


    

    

    //replaceMome
    

    import round from 'lodash/round.js';

    


    const $device = useDevice();
    const { isMobile,isDesktop } = useDevice();
    const route = useRoute();

    
    definePageMeta({
        layout: "default",

    });
    
    
    const toast = useToast();
    
    const productCart = useCookie('productCart');
    productCart.value = productCart.value||[];

    


    let showcanvasmenubrands= ref(false);
    let groupProductsLimit= ref(0);
    let showsortdirectionmoney= ref(false);
    let sortdirection= ref("");
    let currentPage= ref(0);;
 let boLoc =ref({listBrandFilterId: [],
    listFilterBrandId: []});
let productCartItem= ref({amount: 0,
    product: "",
    finalPrice: 0});










    //   variables
    if(process.env.NODE_ENV==='development'){

    }




    const setParam =  function(key,value){
        let objParams = {...route.params};
        let objQuery = {...route.query};
        if(value===undefined){
            delete objParams[key];
        }else{
            objParams[key] = value;
        }
        router.push({
            path: route.path,
            query:objQuery,
            params:objParams
        });
    };
    const setQuery =  function(key,value){
        let objQuery = {...route.query};
        let isChange= false;
        if(value===undefined){
            isChange =true;
            delete objQuery[key];
        }else if(!Array.isArray(value)||(value.length)||(objQuery[key]&& value.length!==objQuery[key].length)){
            isChange =true;
        }
        if(isChange){
            objQuery[key] = value;
            router.push({
                path: route.path,
                query:objQuery
            });
        }
    };
    const setQuerys =  function(items,params){
        let objQuery = {...route.query};
        let isChange= false;
        items.forEach((item)=>{
            const {key,value} =item;
            if(value===undefined){
                isChange =true;
                delete objQuery[key];
            }else if(!Array.isArray(value)||(value.length)||(objQuery[key]&& value.length!==objQuery[key].length)){
                isChange =true;
            }
            if(isChange){
                objQuery[key] = value;

            }
        })

        let objParam={};
        items.forEach((item)=>{
            const {key,value} =item;
            if(value===undefined){
                isChange =true;
                delete objParam[key];
            }else if(!Array.isArray(value)||(value.length)||(objParam[key]&& value.length!==objParam[key].length)){
                isChange =true;
            }
            if(isChange){
                objParam[key] = value;

            }
        })
        if(isChange){
            router.push({
                path: params?('/danh-muc/'+params):route.path,
                query:objQuery
            });
        }

    };
    





    // computed
    

    //attributesCal 0

    


        // computed





        const clearTypeName = (api)=>{
            const funF = (obj)=>{
                if(obj){
                    console.log('obj')
                    Object.keys(obj).forEach((key)=>{
                        if(key==="__typename"){
                            delete obj.__typename;
                        } else if(Array.isArray(obj[key])){
                            obj[key].forEach((item)=>{
                                if(item)
                                    funF(item);
                            });
                        } else if(typeof (obj[key]) ==="object"&&(obj[key])){
                            if(obj[key])
                                funF(obj[key]);
                        }
                    });}
            };
            funF(api);
            return api;
        };



        //methods


    

// mutation

        

    
    const router = useRouter();
    


    
    const loadDatahomeSectionDetail = async function(){
         await new Promise((re)=>{setTimeout(()=>{re(true)},70)});

let variablehomeSectionDetail={};

variablehomeSectionDetail.slug=slug;
 const resulthomeSectionDetailtemp = await useAsyncQuery( gql` query    
  homeSectionsBySlug($slug: String!){
     homeSectionDetail:  homeSectionsBySlug(slug:$slug)
     {
                sectionName listProducts{ _id  name  image  price  groupProduct  slug  productBrands{ _id  createdAt  updatedAt  name  slug  banner  thumbnail  description  status  arrayMediaPlus  widthBanner  highlight  orderNumber  }  status  marketPrice  sellcount  } banner soLuongMacDinh type slug productsId 
        }

}`,variablehomeSectionDetail);
if(resulthomeSectionDetailtemp.data&&resulthomeSectionDetailtemp.data.value.homeSectionDetail){
homeSectionDetail.value = {...resulthomeSectionDetailtemp.data.value.homeSectionDetail}};
;

    };

    const div86361663fdab98dfa50da06a1bd0ac9f9d5fd279click = async function(){
        setQuery('sort','asc');await loadDatahomeSectionDetail();showsortdirectionmoney.value=false;
    };
    const divfd367d85fb44e2302c49f15815e46f24538072dfclick = async function(){
        setQuery('sort','desc');await loadDatahomeSectionDetail();showsortdirectionmoney.value=false;
    };
    





        //1 setup
        

        let homeSectionDetail= ref({});
let listProductBrandss= ref([]);
let groupProductBySections= ref([]);
let listProductByHomesections= ref([]);
let websiteConfig= ref({});

        const slug=route.params['slug'];

let variablehomeSectionDetail={};

variablehomeSectionDetail.slug=slug;
 const resulthomeSectionDetail = await useAsyncQuery(gql` query    
  homeSectionsBySlug($slug: String!){
     homeSectionDetail:  homeSectionsBySlug(slug:$slug)
     {
                sectionName listProducts{ _id  name  image  price  groupProduct  slug  productBrands{ _id  createdAt  updatedAt  name  slug  banner  thumbnail  description  status  arrayMediaPlus  widthBanner  highlight  orderNumber  }  status  marketPrice  sellcount  } banner soLuongMacDinh type slug productsId 
        }

}`,variablehomeSectionDetail);
if(resulthomeSectionDetail.data.value&&resulthomeSectionDetail.data.value.homeSectionDetail){
homeSectionDetail.value = {...resulthomeSectionDetail.data.value.homeSectionDetail,};}

let variablelistProductBrandss={};

const resultlistProductBrandss = await useAsyncQuery(gql` query    
 productBrandss($query: productBrandsFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     listProductBrandss:  productBrandss(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                name slug banner thumbnail description status arrayMediaPlus widthBanner highlight 
        }

}`,variablelistProductBrandss);
if(resultlistProductBrandss.data.value&&resultlistProductBrandss.data.value.listProductBrandss){
listProductBrandss.value = resultlistProductBrandss.data.value.listProductBrandss}

let variablegroupProductBySections={limit: 15,sort :{highlight:-1}, query :{}};

                                    if(homeSectionDetail.value&&homeSectionDetail.value.length){
                                    variablegroupProductBySections.query._id = {in: homeSectionDetail.value }
                                    
                                    }
                              

const resultgroupProductBySections = await useAsyncQuery(gql` query    
 groupProducts($query: groupProductFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     groupProductBySections:  groupProducts(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id name icon slug thumbnail highlight groupProduct propertyProduct{ name  key  typeValue  values  } status 
        }

}`,variablegroupProductBySections);
if(resultgroupProductBySections.data.value&&resultgroupProductBySections.data.value.groupProductBySections){
groupProductBySections.value = resultgroupProductBySections.data.value.groupProductBySections}

let variablelistProductByHomesections={query :{}};

                                    if(homeSectionDetail.value.listProducts&&homeSectionDetail.value.listProducts!==''){
                                    variablelistProductByHomesections.query._id = {in: homeSectionDetail.value.listProducts } //huyêweer
                                    
                                    }
                              

const resultlistProductByHomesections = await useAsyncQuery(gql` query    
 products($query: productFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     listProductByHomesections:  products(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id name image price groupProduct slug labelPrice property productBrands{ _id  createdAt  updatedAt  name  slug  banner  thumbnail  description  status  arrayMediaPlus  widthBanner  highlight  orderNumber  } status 
        }

}`,variablelistProductByHomesections);
if(resultlistProductByHomesections.data.value&&resultlistProductByHomesections.data.value.listProductByHomesections){
listProductByHomesections.value = resultlistProductByHomesections.data.value.listProductByHomesections}

let variablewebsiteConfig={};

const resultwebsiteConfig = await useAsyncQuery(gql` query {  websiteConfig {
                _id logo tenThuongHieuSeo 
        } }`,variablewebsiteConfig);
if(resultwebsiteConfig.data.value&&resultwebsiteConfig.data.value.websiteConfig){
websiteConfig.value = {...resultwebsiteConfig.data.value.websiteConfig}}








        //1 afterData
        
    currentPage.value=1; if(route.query['page']){
                                    let value =  parseInt(route.query['page']);
                                    if(value ){
                                    currentPage.value = value  ;
                                    }
                              }

    


        


        

        

        



        
        const methods=()=>{
            
        }

        





  // watch



    











    //meta
        

        const meta = [  {name: "theme-color" ,content:"#fff"}];
        let title = '';

    title =''


         title= homeSectionDetail?.value.sectionName;
            meta.push({ name: 'title', content:homeSectionDetail?.value.sectionName });
            
            meta.push({ name: 'description', content:homeSectionDetail?.value.sectionName+' tại '+websiteConfig?.value.tenThuongHieuSeo });
            
            meta.push({ name: 'og:image', content:websiteConfig?.value.logo });
            


   const bodyAttrs ={};
    const  htmlAttrs={};
    



        useHead({
            title: title,
            viewport: 'width=device-width, initial-scale=1, maximum-scale=1',
            charset: 'utf-8',
            meta: meta,
            htmlAttrs:htmlAttrs,
            bodyAttrs:bodyAttrs,
            script: [
                    
            ],
            
            link:[

                
                { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.4.1/css/simple-line-icons.min.css' }, 
                
                
                
                { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css' }, 
               
                    
            ]
            
        })
    


</script>


<!--false-->
<script>


    
    export default {
        name: "bo-suu-tap-slug",

        

        data(){
            return {

                }
            },
                methods:{




    }

        }
</script>

//update in Fri Oct 04 2024 13:51:48 GMT+0700 (Indochina Time) by loidirieng
